"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
const player_1 = require("../types/player");
const event_1 = require("./event");
const fileLoader_1 = require("../utils/fileLoader");
const Sample_1 = require("./Sample");
const utils_1 = require("@sfz-tools/core/dist/utils");
const parse_1 = require("@sfz-tools/core/dist/parse");
class Audio extends event_1.default {
    constructor(options) {
        super();
        this.preload = player_1.AudioPreload.ON_DEMAND;
        this.regions = [];
        this.bend = 0;
        this.chanaft = 64;
        this.polyaft = 64;
        this.bpm = 120;
        this.regionDefaults = {
            lochan: 0,
            hichan: 15,
            lokey: 0,
            hikey: 127,
            lovel: 0,
            hivel: 127,
            lobend: -8192,
            hibend: 8192,
            lochanaft: 0,
            hichanaft: 127,
            lopolyaft: 0,
            hipolyaft: 127,
            lorand: 0,
            hirand: 1,
            lobpm: 0,
            hibpm: 500,
        };
        if (!window.AudioContext)
            window.alert('Browser does not support WebAudio');
        this.context = new window.AudioContext();
        if (window.webAudioControlsWidgetManager) {
            window.webAudioControlsWidgetManager.addMidiListener((event) => this.onKeyboard(event));
        }
        else {
            console.log('webaudio-controls not found, add to a <script> tag.');
        }
        if (options.loader) {
            this.loader = options.loader;
        }
        else {
            this.loader = new fileLoader_1.default();
        }
        // Use shared loader
        // parseSetLoader(this.loader);
        if (options.root)
            this.loader.setRoot(options.root);
        if (options.file) {
            const file = this.loader.addFile(options.file);
            this.showFile(file);
        }
        if (options.preload)
            this.preload = options.preload;
    }
    showFile(file) {
        return __awaiter(this, void 0, void 0, function* () {
            this.dispatchEvent('preload', {
                status: `Loading sfz files`,
            });
            this.dispatchEvent('loading', true);
            file = yield this.loader.getFile(file);
            if (!file)
                return;
            console.log('showFile', file);
            const prefix = (0, utils_1.pathGetDirectory)(file.path);
            console.log('prefix', prefix);
            let headers = [];
            if (file.ext === 'sfz') {
                headers = yield (0, parse_1.parseSfz)(file === null || file === void 0 ? void 0 : file.contents, prefix);
                console.log('headers', headers);
            }
            else if (file.ext === 'json') {
                headers = JSON.parse(file === null || file === void 0 ? void 0 : file.contents).elements;
            }
            this.regions = (0, parse_1.parseHeaders)(headers, prefix);
            this.regions = this.midiNamesToNum(this.regions);
            console.log('regions', this.regions);
            console.log('preload', this.preload);
            if (this.preload === player_1.AudioPreload.SEQUENTIAL) {
                yield this.preloadFiles(this.regions);
            }
            else {
                this.dispatchEvent('keyboardMap', this.getKeyboardMap(this.regions));
            }
            this.dispatchEvent('loading', false);
        });
    }
    getKeyboardMap(regions) {
        const keyboardMap = {};
        regions.forEach((region) => {
            this.updateKeyboardMap(region, keyboardMap);
        });
        return keyboardMap;
    }
    midiNameToNumConvert(val) {
        if (typeof val === 'number')
            return val;
        const isLetters = /[a-zA-Z]/g;
        if (isLetters.test(val))
            return (0, utils_1.midiNameToNum)(val);
        return parseInt(val, 10);
    }
    midiNamesToNum(regions) {
        for (const key in regions) {
            const region = regions[key];
            if (region.lokey)
                region.lokey = this.midiNameToNumConvert(region.lokey);
            if (region.hikey)
                region.hikey = this.midiNameToNumConvert(region.hikey);
            if (region.key)
                region.key = this.midiNameToNumConvert(region.key);
            if (region.pitch_keycenter)
                region.pitch_keycenter = this.midiNameToNumConvert(region.pitch_keycenter);
        }
        return regions;
    }
    updateKeyboardMap(region, keyboardMap) {
        if (!region.lokey && region.key)
            region.lokey = region.key;
        if (!region.hikey && region.key)
            region.hikey = region.key;
        const merged = Object.assign({}, this.regionDefaults, region);
        for (let i = merged.lokey; i <= merged.hikey; i += 1) {
            keyboardMap[i] = true;
        }
    }
    preloadFiles(regions) {
        return __awaiter(this, void 0, void 0, function* () {
            const keyboardMap = {};
            this.dispatchEvent('keyboardMap', keyboardMap);
            let start = 0;
            const end = Object.keys(regions).length - 1;
            for (const key in regions) {
                this.dispatchEvent('preload', {
                    status: `Loading audio files: ${start} of ${end}`,
                });
                const samplePath = regions[key].sample;
                if (!samplePath || samplePath.includes('*'))
                    continue;
                yield this.loader.getFile(samplePath, true);
                start += 1;
                this.updateKeyboardMap(regions[key], keyboardMap);
                this.dispatchEvent('keyboardMap', keyboardMap);
            }
        });
    }
    checkRegion(region, controlEvent, rand) {
        return (region.sample != null &&
            region.lochan <= controlEvent.channel &&
            region.hichan >= controlEvent.channel &&
            region.lokey <= controlEvent.note &&
            region.hikey >= controlEvent.note &&
            region.lovel <= controlEvent.velocity &&
            region.hivel >= controlEvent.velocity &&
            region.lobend <= this.bend &&
            region.hibend >= this.bend &&
            region.lochanaft <= this.chanaft &&
            region.hichanaft >= this.chanaft &&
            region.lopolyaft <= this.polyaft &&
            region.hipolyaft >= this.polyaft &&
            region.lorand <= rand &&
            region.hirand >= rand &&
            region.lobpm <= this.bpm &&
            region.hibpm >= this.bpm);
    }
    checkRegions(regions, controlEvent) {
        const random = Math.random();
        return regions.filter((region) => {
            if (!region.lokey && region.key)
                region.lokey = region.key;
            if (!region.hikey && region.key)
                region.hikey = region.key;
            const merged = Object.assign({}, this.regionDefaults, region);
            return this.checkRegion(merged, controlEvent, random);
        });
    }
    onKeyboard(event) {
        const controlEvent = {
            channel: 1,
            note: event.data[1],
            velocity: event.data[0] === 128 ? 0 : event.data[2],
        };
        this.update(controlEvent);
        this.dispatchEvent('change', controlEvent);
    }
    update(event) {
        return __awaiter(this, void 0, void 0, function* () {
            // prototype using samples
            if (event.velocity === 0) {
                return;
            }
            console.log('event', event);
            const regionsFiltered = this.checkRegions(this.regions, event);
            console.log('regionsFiltered', regionsFiltered);
            if (!regionsFiltered.length)
                return;
            const randomSample = Math.floor(Math.random() * regionsFiltered.length);
            const keySample = regionsFiltered[randomSample];
            console.log('keySample', keySample);
            const fileRef = this.loader.files[keySample.sample];
            const newFile = yield this.loader.getFile(fileRef || keySample.sample, true);
            const sample = new Sample_1.default(this.context, newFile === null || newFile === void 0 ? void 0 : newFile.contents, keySample);
            sample.setPlaybackRate(event);
            sample.play();
        });
    }
    reset() {
        // this.sampler.stop();
        // this.keys = [];
    }
}
exports.default = Audio;
